import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper';
import styles from './BottomSlider.module.css';

const slidesUrls = [
  'https://static.uchi.ru/files/otvety/AuthModal/answers_count_slider.svg',
  'https://static.uchi.ru/files/otvety/AuthModal/ai_helper.svg',
  'https://static.uchi.ru/files/otvety/AuthModal/ai_instruments.svg',
  'https://static.uchi.ru/files/otvety/AuthModal/trusted_answers.svg',
];

const BottomSlider = () => {
  return (
    <Swiper
      slidesPerView={'auto'}
      centeredSlides={true}
      spaceBetween={12}
      className={styles.swiper}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      breakpoints={{
        320: {
          spaceBetween: 12,
          slidesPerView: 'auto',
          centeredSlides: false,
          loop: true,
        },
        768: {
          spaceBetween: 12,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: false,
        },
      }}
      modules={[Autoplay]}
    >
      {slidesUrls.map((url, index) => (
        <SwiperSlide key={index} className={styles.slider}>
          <img src={url} alt="" className={styles.swiper_element} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BottomSlider;
